interface AnimatedSectionProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  animation?: 'fade-up' | 'fade-in' | 'slide-left' | 'slide-right' | 'scale';
}

export const AnimatedSection = ({ 
  children, 
  className = ''
}: AnimatedSectionProps) => {
  return (
    <section className={className}>
      {children}
    </section>
  );
};
